
// Attach to document (or a static parent element)
$(document).on("click", "[href^='#']", function(e) {
    e.preventDefault(); // prevent default anchor jump
    var id = $(this).attr("href");
    if ($(id).length) {
        $("body").removeClass("mobile__menu-open cart-open");
        $(".header__mobi-menu, .header__mobi-left-text-close").removeClass("active");
        $('html, body').animate({
            scrollTop: $(id).offset().top
        }, 1000);
    }
});
// {% if language.iso_code == localization.language.iso_code %}selected{% endif %}


// window.addEventListener("DOMContentLoaded", () => {
//   function currencyHandler(e) {
//     e.target.form.submit();
//     alert()
//   }
//   document.querySelectorAll(".top-header__curr-select").forEach((elm) => {
//     elm.addEventListener("change", currencyHandler);
//   });
// });
